export default "__VITE_ASSET__D3vouQa8__"